const turnoSaldadoInitialState = {
  turnoSaldado: {
    loading: false,
    error: null,
    data: null,
  },
};

export default turnoSaldadoInitialState;
